// extracted by mini-css-extract-plugin
export default {"statsWrapper":"ELPDSDetails_statsWrapper__MoQZE","eachStats":"ELPDSDetails_eachStats__+3TH1"};